import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

function Timeline({ education }) {
  const { years, title, location, content } = education;
  return (
    <ScrollAnimation
      animateIn="fadeInUp"
      animateOut="fadeInOut"
      animateOnce={true}
    >
      <div className="timeline-container">
        <div className="content">
          <span className="time">{years}</span>
          <h6 className="title">{title}</h6>
          <p className="location">{location}</p>
          <br/>
        </div>
      </div>
    </ScrollAnimation>
  );
}

export default Timeline;
